import { Component, OnInit } from '@angular/core';
import { SkeletonSizeBase } from '../../../common/Models/SkeletonSizesBase';

@Component({
  selector: 'skc-card-avatar',
  templateUrl: './card-avatar.component.html',
  styleUrls: ['./card-avatar.component.less']
})
export class CardAvatarComponent extends SkeletonSizeBase implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
